import React, { useEffect, useState } from 'react';

import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi, DialogUI } from '../Interface';
import { dataGridPremiumColumns } from '../../utils/helper';
import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';

const DownPaymentTableDialog = (props) => {
  const { values, setFieldValue } = useFormikContext();
  const { open, onClose, data, defaultDocumentLine } = props;
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const columns = dataGridPremiumColumns([
    {
      field: 'docNum',
      headerName: 'Előlegszámla száma',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        return data.row.doc?.docNum;
      },
    },
    {
      field: 'note',
      headerName: 'Megjegyzés',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        return data.row.doc?.note;
      },
    },
    {
      field: 'currencyCode',
      headerName: 'Előleg pénzneme',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        return data.row.doc?.currencyCode;
      },
    },
    {
      field: 'itemName',
      headerName: 'Cikk megnevezés',
      type: 'string',
      filterable: false,
    },
    {
      field: 'vatCode',
      headerName: 'Áfa kód',
      type: 'string',
      filterable: false,
    },
    {
      field: 'netPrice',
      headerName: 'Nettó érték',
      type: 'number',
      filterable: false,
    },
    {
      field: 'vatValue',
      headerName: 'Áfa érték',
      type: 'number',
      filterable: false,
    },
    {
      field: 'grossPrice',
      headerName: 'Bruttó érték',
      type: 'number',
      filterable: false,
    },
  ]);

  const handleSelectRows = () => {
    const nextVisOrder =
      (values.docLine ?? []).reduce((maxOrder, line, index) => {
        const visOrder = line?.visOrder !== null && line?.visOrder !== undefined ? Number(line.visOrder) : NaN;
        const lineNum = line?.lineNum !== null && line?.lineNum !== undefined ? Number(line.lineNum) : NaN;
        const currentOrder = Number.isFinite(visOrder)
          ? visOrder
          : Number.isFinite(lineNum)
            ? lineNum
            : index;
        return Math.max(maxOrder, currentOrder);
      }, 0) + 1;

    const selectedRows = data
      .filter((row) => rowSelectionModel.includes(`${row.lineNum}_${row.doc.docId}`))
      .map((row, index) => {
        const { doc, ...rest } = row;

        const normalized = {
          ...defaultDocumentLine,
          ...rest,
          id: uuidv4(),
          visOrder: nextVisOrder + index,
          unitPrice: row.unitPrice ? -Math.abs(Number(row.unitPrice)) : 0,
          baseId: doc?.docId ?? null,
          baseDocnum: doc?.docNum ?? null,
          baseDocType: doc?.docTypeId ?? null,
          baseLine: row.lineNum,
        };

        return normalized;
      });

    setFieldValue('docLine', [...(values.docLine ?? []), ...selectedRows]);
    onClose();
  };

  return (
    <DialogUI open={open} onClose={onClose} headerContent="Előleg" maxWidth="xl" fullWidth>
      <DatagridPremiumUi
        datagridIdentifier={DataGridIdentifiers.DownPaymentDialog}
        datagridInitialState={{ density: 'compact' }}
        rows={data}
        hideFooter
        height={700}
        columns={columns}
        headerFilters={false}
        getRowId={(row) => `${row.lineNum}_${row.doc.docId}`}
        paginationAndfilterMode="client"
        checkboxSelection
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={(newModel) => setRowSelectionModel(newModel)}
      />

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        <ButtonUI
          text="Előleg beolvasása"
          className="bg-success"
          onClick={handleSelectRows}
          disabled={rowSelectionModel?.length === 0}
        />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default DownPaymentTableDialog;
